const isMobile = () => {
  if (window.innerWidth > 720) {
    return false;
  }
  return true;
};

export default isMobile;
